// import { injected } from "./utils/Web3Connectors";
import React, { useEffect } from "react";
// import { Card, CardBody, CardTitle } from "reactstrap";
import { Button, Spinner } from "reactstrap";
import { googleWallet } from "../../connectors/googleWallet";
import { FcGoogle } from "react-icons/fc";
import { useDispatch, useSelector } from "react-redux";
import { setStatus } from "../../app/authConnect";

const GoogleConnectButton = (props) => {
  const dispatch = useDispatch();
  const connectionStatus = useSelector((state) => state.authConnect.status);
  const setConnectionStatus = (status) => dispatch(setStatus(status));
  const connecting = connectionStatus === "connecting";
  const starting = connectionStatus === "starting";
  const signing = connectionStatus === "signing";
  const loading = connecting || starting || signing;

  //props from web 3 must be instantiated wherever function is used
  const urlParams = new URLSearchParams(window.location.hash);
  const sessionId = urlParams.get("#sessionId");
  const web3AuthRedirectParams = urlParams.get("#b64Params");
  // useEffect(() => {
  //   void googleWallet
  //     .connectEagerly()
  //     .then(() => {
  //       console.debug("Connected eagerly to web3-auth");
  //       dispatch(setKeepWalletConnection(true));
  //     })
  //     .catch(() => {
  //       console.debug("Failed to connect eagerly to web3-auth");
  //     });
  // }, []);
  useEffect(() => {
    if (web3AuthRedirectParams) {
      handleConnect();
    }
  }, [web3AuthRedirectParams]);

  useEffect(() => {
    if (sessionId) {
      handleConnect();
    }
  }, [sessionId]);

  const handleConnect = () => {
    setConnectionStatus("starting");
    if (googleWallet) {
      googleWallet
        .setOptions({
          clientId: process.env.REACT_APP_WTA_ID,
          authConnectionId: process.env.REACT_APP_WTA_GOOGLE_VERIFIER,
          setStatus: setConnectionStatus,
          loginMethods: {
            google: {
              name: "google login",
              authConnectionId: process.env.REACT_APP_WTA_GOOGLE_VERIFIER,
            },
          },
        })
        .then(() => googleWallet.activate())
        .then(() => {
          console.log("connected");
        })
        .catch((err) => console.error(err));
    }
  };

  // useEffect(() => {
  //   handleConnect();
  // }, []);

  return (
    <Button
      onClick={() => handleConnect()}
      className={`text-start py-2 mb-3 fw-bold nav-button border-0 rounded-0 ps-lg-5 ${
        false && "active"
      }`}
      block
      color="transparent"
      disabled={loading}
    >
      {loading && <Spinner color="secondary" size="sm" className="me-2" />}
      <FcGoogle alt={"Google"} size={32} className="me-4" />
      <span className="h5 fw-bold">{"Google"}</span>
    </Button>
  );
};

export default GoogleConnectButton;
